<template>
  <div class="col-12 col-lg-6 c g">
    <div class="card" v-if="success">
        <div class="card-body">
            <div class="alertd alert-success text-center text-success g">
                <h3>
                    <img :src="require('@/assets/images/done.png')" style="border-radius: 50%; width: 120px" alt="">
                    <br><br>
                    {{ success }}
                </h3>
            </div>
        </div>
    </div>
    <div class="card" v-if="error">
        <div class="card-body">
            <div class="alertd alert-danger text-center text-danger g">
                <h3>
                    {{ error }}
                </h3>
            </div>
        </div>
    </div>
    <div class="card" v-if="!success && !error">
        <div class="card-header">
            <h5><i class="fa fa-user-plus"></i> التسجيل</h5>
            (الخطوة {{ step }} من {{ totalPages }})
        </div>
        <div class="card-body">
            <strong class="text-danger">* تشير إلى أنّ السؤال مطلوب</strong>
        </div>
        <div class="card-body" style="padding: 10px" v-if="step == 1">
            <div class="form-group g borders" style="border-radius: 5px">
              <h5 for=""><i class="fa fa-edit"></i> الاسم الرباعي</h5>
              <input type="text"
                class="form-control form-control-lg bg-white" readonly v-model="create.name" placeholder="اكتب هنا...">
            </div>
            <div class="form-group g">
              <h5 for=""><i class="fa fa-edit"></i> رقم الجوال </h5>
              <input type="number"
                class="form-control form-control-lg bg-white" readonly v-model="create.phone" placeholder="اكتب هنا...">
            </div>
            <div class="form-group g borders" style="border-radius: 5px">
              <h5 for=""><i class="fa fa-edit"></i> البريد الالكتروني <strong class="text-danger">*</strong></h5>
              <input type="email"
                class="form-control form-control-lg" v-model="create.email" placeholder="اكتب هنا...">
            </div>
            <div class="form-group g borders" style="border-radius: 5px">
              <h5 for=""><i class="fa fa-edit"></i> رقم الهوية
            <strong class="text-danger">*</strong></h5>
              <input type="text"
                class="form-control form-control-lg" v-model="create.number" placeholder="اكتب هنا...">
            </div>
            <div class="form-group g borders" style="border-radius: 5px">
              <h5 for=""><i class="fa fa-edit"></i> مصدر الهوية
            <strong class="text-danger">*</strong></h5>
              <input type="text"
                class="form-control form-control-lg" v-model="create.number_source" placeholder="اكتب هنا...">
            </div>
            <div class="form-group g borders" style="border-radius: 5px">
              <h5 for=""><i class="fa fa-edit"></i> تاريخ الميلاد بالتقويم الملادي
            <strong class="text-danger">*</strong></h5>
              <input type="date"
                class="form-control form-control-lg" v-model="create.birth_date" placeholder="اكتب هنا...">
            </div>
            <div class="form-group g borders" style="border-radius: 5px">
              <h5 for="" class=""><i class="fa fa-edit"></i> الجنس
            <strong class="text-danger">*</strong></h5>
              <div class="form-check" style="margin-top: 10px !important">
                <label class="form-check-label">
                  <input type="radio" class="form-check-input" v-model="create.gender" value="man">
                  <h5>
                    ذكر
                  </h5>
                </label>
              </div>
              <div class="form-check">
                <label class="form-check-label">
                  <input type="radio" class="form-check-input" v-model="create.gender" value="woman">
                  <h5>
                    أنثى
                  </h5>
                </label>
              </div>
            </div>
            <div class="form-group g">
              <h5 for=""><i class="fa fa-edit"></i> الجنسية
            <strong class="text-danger">*</strong></h5>
              <select class="form-control form-control-lg" v-model="create.national">
                <option v-for="v in contry" :key="v" :value="v">{{ v }}</option>
              </select>
            </div>

            <h5 class="g">
                <i class="fa fa-edit"></i>
                صورة من الهوية الوطنية أو الإقامة سارية بنفس النموذج المرفق :
            <strong class="text-danger">*</strong>
            </h5>
            <div class="col-12 text-center">
                <img :src="require('@/assets/images/number-form.jpg')" style="width: 90%; margin: 0px auto; border: 3px #48A6A7 dashed; padding: 5px" alt=""> 
                <div class="form-group text-left g">
                    <br>
                  <h5 for="">ارفاق صورة الهوية الوطنية

                    <span v-if="create.file_1 == 'uploading'">
                        <img :src="require('@/assets/images/loading.svg')" alt="" width="24"> جاري الرفع
                    </span>
                    <span v-if="create.file_1 != '' && create.file_1" class="text-success">
                        (تم الرفع)
                    </span>
                  </h5>
                  <input type="file"
                    class="form-control" id="file_1" @change="create.file_1 = 'uploading'; upload1()" accept=".jpg,.jpeg,.png,.pdf">
                </div>
            </div>
            <div class="form-group text-left g">
                <h5 for="">الصورة الشخصية لإصدار بطاقة نسك
            <strong class="text-danger">*</strong>
                    <span v-if="create.file_3 == 'uploading'">
                        <img :src="require('@/assets/images/loading.svg')" alt="" width="24"> جاري الرفع
                    </span>
                    <span v-if="create.file_3 != '' && create.file_3" class="text-success">
                        (تم الرفع)
                    </span>
                </h5>
                <input type="file"
                class="form-control" id="file_3" @change="create.file_3 = 'uploading'; upload3()" accept=".jpg,.jpeg,.png,.pdf">
            </div>
            <div class="col-12 text-center g">
                <button class="btn btn-primary" @click="step = 2; top();">
                    الخطوة التالية <i class="fa fa-arrow-left"></i>
                </button>
                <br><br>
            </div>
        </div>
        <div class="card-body" style="padding: 10px" v-if="step == 2">
            <div class="form-group text-left g">
                <h5 for="">شهادة الآيبان الخاص بالحساب البنكي للمتقدم
            <strong class="text-danger">*</strong>

                    <span v-if="create.file_2 == 'uploading'">
                        <img :src="require('@/assets/images/loading.svg')" alt="" width="24"> جاري الرفع
                    </span>
                    <span v-if="create.file_2 != '' && create.file_2" class="text-success">
                        (تم الرفع)
                    </span>
                </h5>
                <input type="file"
                class="form-control" id="file_2" @change="create.file_2 = 'uploading'; upload2()" accept=".jpg,.jpeg,.png,.pdf">
            </div>

            <div class="form-group g">
              <h5 for=""><i class="fa fa-edit"></i> رقم الحساب البنكي ( الآيبان ) بدون ( SA )
            <strong class="text-danger">*</strong></h5>
              <input type="text"
                class="form-control form-control-lg" v-model="create.bank_number" placeholder="اكتب هنا...">
            </div>
            <div class="form-group g">
              <h5 for=""><i class="fa fa-edit"></i> البنك الذي عليه الحساب 
            <strong class="text-danger">*</strong></h5>
              <input type="text"
                class="form-control form-control-lg" v-model="create.bank" placeholder="اكتب هنا...">
            </div>
            <div class="col-12 text-center g">
                <button class="btn btn-primary" @click="step = 3; top()">
                    الخطوة التالية <i class="fa fa-arrow-left"></i>
                </button>
                <br><br>
                <a href="javascript:;" class="text-muted" @click="step = 1; top()"><i class="fa fa-share"></i> الصفحة السابقة</a>
            </div>
        </div>
        <div class="card-body" style="padding: 10px" v-if="step == 3">
            <div class="form-group g borders" style="border-radius: 5px">
              <h5 for="" class=""><i class="fa fa-edit"></i> هل سبق لك الحج ؟
            <strong class="text-danger">*</strong></h5>
              <div class="form-check" style="margin-top: 10px !important">
                <label class="form-check-label">
                  <input type="radio" class="form-check-input" v-model="create.hij_before" value="yes">
                  <h5>
                    نعم
                  </h5>
                </label>
              </div>
              <div class="form-check">
                <label class="form-check-label">
                  <input type="radio" class="form-check-input" v-model="create.hij_before" value="no">
                  <h5>
                    لا
                  </h5>
                </label>
              </div>
            </div>
            <div class="form-group g borders" style="border-radius: 5px">
              <h5 for="" class=""><i class="fa fa-edit"></i> هل سبق لك أن عملت في حملات الحج ؟
            <strong class="text-danger">*</strong></h5>
              <div class="form-check" style="margin-top: 10px !important">
                <label class="form-check-label">
                  <input type="radio" class="form-check-input" v-model="create.work_before" value="yes">
                  <h5>
                    نعم
                  </h5>
                </label>
              </div>
              <div class="form-check">
                <label class="form-check-label">
                  <input type="radio" class="form-check-input" v-model="create.work_before" value="no">
                  <h5>
                    لا
                  </h5>
                </label>
              </div>
            </div>
            <div class="form-group g borders" style="border-radius: 5px">
              <h5 for=""><i class="fa fa-edit"></i> آخر مؤهل تم الحصول عليه <strong class="text-danger">*</strong></h5>
              <input type="text"
                class="form-control form-control-lg bg-white"  v-model="create.last_degree" placeholder="اكتب هنا...">
            </div>
            <div class="form-group text-left g">
                <h5 for="">صورة المؤهل
                    <span v-if="create.file_4 == 'uploading'">
                        <img :src="require('@/assets/images/loading.svg')" alt="" width="24"> جاري الرفع
                    </span>
                    <span v-if="create.file_4 != '' && create.file_4" class="text-success">
                        (تم الرفع)
                    </span>
                </h5>
                <input type="file"
                class="form-control" id="file_4" @change="create.file_4 = 'uploading'; upload4()" accept=".jpg,.jpeg,.png,.pdf">
            </div>
            <div class="form-group g">
              <h5 for=""><i class="fa fa-edit"></i> اكتب عن نفسك وخبراتك :
            <strong class="text-danger">*</strong></h5>
              <input type="text"
                class="form-control form-control-lg" v-model="create.about" placeholder="اكتب هنا...">
            </div>
            <div class="col-12 text-center g">
                <button class="btn btn-success" style="background: #578E7E !important; border: none" @click="done()" v-if="create.gender == 'man'">
                    <i class="fa fa-check"></i>
                    إرسال الآن
                </button>
                <button class="btn btn-success" style="background: #578E7E !important; border: none" @click="step=4; top()" v-if="create.gender != 'man'">
                    الخطوة التالية <i class="fa fa-arrow-left"></i>
                </button>
                <br><br>
                <a href="javascript:;" class="text-muted" @click="step = 2; top()"><i class="fa fa-share"></i> الصفحة السابقة</a>
            </div>
        </div>
        <div class="card-body" style="padding: 10px" v-if="step == 4">
            <div class="form-group g borders" style="border-radius: 5px">
              <h5 for=""><i class="fa fa-edit"></i> اسم المحرم <strong class="text-danger"></strong></h5>
              <input type="text"
                class="form-control form-control-lg" v-model="create.muhrim" placeholder="اكتب هنا...">
            </div>
            <div class="form-group g borders" style="border-radius: 5px">
              <h5 for=""><i class="fa fa-edit"></i> رقم هوية المحرم <strong class="text-danger">*</strong></h5>
              <input type="text"
                class="form-control form-control-lg" v-model="create.muhrim_number" placeholder="اكتب هنا...">
            </div>
            <div class="form-group g borders" style="border-radius: 5px">
              <h5 for=""><i class="fa fa-edit"></i> رقم جوال المحرم <strong class="text-danger">*</strong></h5>
              <input type="text"
                class="form-control form-control-lg" v-model="create.muhrim_phone" placeholder="اكتب هنا...">
            </div>
            <div class="col-12 text-center g">
                <button class="btn btn-success" style="background: #578E7E !important; border: none" @click="done()">
                    <i class="fa fa-check"></i>
                    إرسال الآن
                </button>
                <br><br>
                <a href="javascript:;" class="text-muted" @click="step = 2; top()"><i class="fa fa-share"></i> الصفحة السابقة</a>
            </div>
        </div>
    </div>
  </div>
</template>

            
<script>
export default {
    data(){
        return {
            step: 1,
            totalPages: 3,
            create: {
              national: "السعودية"
            },
            success: null,
            code: window.location.href.split("/join/")[1],
            error: null,
            contry: [
                "السعودية",
                "مصر",
                "أفغانستان",
                "ألبانيا",
                "الجزائر",
                "أندورا",
                "أنغولا",
                "أنتيغوا وبربودا",
                "الأرجنتين",
                "أرمينيا",
                "أستراليا",
                "النمسا",
                "أذربيجان",
                "جزر البهاما",
                "البحرين",
                "بنغلاديش",
                "بربادوس",
                "بيلاروسيا",
                "بلجيكا",
                "بليز",
                "بنين",
                "بوتان",
                "بوليفيا",
                "البوسنة والهرسك",
                "بوتسوانا",
                "البرازيل",
                "بروناي",
                "بلغاريا",
                "بوركينا فاسو",
                "بوروندي",
                "كمبوديا",
                "الكاميرون",
                "كندا",
                "الرأس الأخضر",
                "جمهورية إفريقيا الوسطى",
                "تشاد",
                "تشيلي",
                "الصين",
                "كولومبيا",
                "جزر القمر",
                "الكونغو",
                "جمهورية الكونغو الديمقراطية",
                "كوستاريكا",
                "كوت ديفوار (ساحل العاج)",
                "كرواتيا",
                "كوبا",
                "قبرص",
                "جمهورية التشيك (تشيكوسلوفاكيا)",
                "الدنمارك",
                "جيبوتي",
                "دومينيكا",
                "جمهورية الدومينيكان",
                "تيمور الشرقية",
                "الإكوادور",
                "السلفادور",
                "غينيا الاستوائية",
                "إريتريا",
                "إستونيا",
                "إثيوبيا",
                "فيجي",
                "فنلندا",
                "فرنسا",
                "الجابون",
                "غامبيا",
                "جورجيا",
                "ألمانيا",
                "غانا",
                "اليونان",
                "جرينلاند",
                "غرينادا",
                "جواتيمالا",
                "غينيا",
                "غينيا بيساو",
                "غيانا",
                "هايتي",
                "هندوراس",
                "المجر",
                "آيسلندا",
                "الهند",
                "إندونيسيا",
                "إيران",
                "العراق",
                "أيرلندا",
                "إسرائيل (فلسطين المحتلة)",
                "إيطاليا",
                "جامايكا",
                "اليابان",
                "الأردن",
                "كازاخستان",
                "كينيا",
                "كيريباتي",
                "كوسوفو",
                "الكويت",
                "قيرغيزستان",
                "لاوس",
                "لاتفيا",
                "لبنان",
                "ليسوتو",
                "ليبيريا",
                "ليبيا",
                "ليختنشتاين",
                "ليتوانيا",
                "لوكسمبورغ",
                "مقدونيا الشمالية",
                "مدغشقر",
                "مالاوي",
                "ماليزيا",
                "جزر المالديف",
                "مالي",
                "مالطا",
                "جزر مارشال",
                "موريتانيا",
                "موريشيوس",
                "المكسيك",
                "ولايات ميكرونيزيا الموحدة",
                "مولدوفا",
                "موناكو",
                "منغوليا",
                "الجبل الأسود",
                "المغرب",
                "موزمبيق",
                "ميانمار (بورما)",
                "ناميبيا",
                "ناورو",
                "نيبال",
                "هولندا",
                "نيوزيلندا",
                "نيكاراغوا",
                "النيجر",
                "نيجيريا",
                "كوريا الشمالية",
                "النرويج",
                "عُمان",
                "باكستان",
                "بالاو",
                "بنما",
                "بابوا غينيا الجديدة",
                "باراغواي",
                "بيرو",
                "الفلبين",
                "بولندا",
                "البرتغال",
                "قطر",
                "رومانيا",
                "روسيا",
                "رواندا",
                "سانت كيتس ونيفيس",
                "سانت لوسيا",
                "سانت فنسنت والجرينادينز",
                "ساموا",
                "سان مارينو",
                "ساو تومي وبرينسيبي",
                "السنغال",
                "صربيا",
                "سيشيل",
                "سيراليون",
                "سنغافورة",
                "سلوفاكيا",
                "سلوفينيا",
                "جزر سليمان",
                "الصومال",
                "جنوب أفريقيا",
                "كوريا الجنوبية",
                "جنوب السودان",
                "إسبانيا",
                "سريلانكا",
                "السودان",
                "سورينام",
                "إسواتيني",
                "مملكة السويد",
                "سويسرا",
                "سوريا",
                "تايوان",
                "طاجيكستان",
                "تنزانيا",
                "تايلاند",
                "توجو",
                "تونغا",
                "ترينيداد وتوباغو",
                "تونس",
                "تركيا",
                "تركمانستان",
                "توفالو",
                "أوغندا",
                "أوكرانيا",
                "الإمارات العربية المتحدة",
                "المملكة المتحدة",
                "الولايات المتحدة الأمريكية",
                "أوروجواي",
                "أوزبكستان",
                "فانواتو",
                "مدينة الفاتيكان",
                "فنزويلا",
                "فيتنام",
                "اليمن",
                "زامبيا",
                "زيمبابوي",
                ""
            ]
        }
    },
    created(){
      var g = this;
      $.post(api + '/user/forms/check', {
          code: g.code
      }).then(function(r){
          if(r.status == 100){
              g.create.name = r.response.name;
              g.create.phone = r.response.phone;
              g.create = JSON.parse(JSON.stringify(g.create))
          }else{
              g.error = r.response
          }
      }).fail(function(){
          g.error = "حدث خطأ في الاتصال"
      })
    },
    methods: {
        top(){
            $("html, body").animate({ scrollTop: 0 }, "slow");
        },
        upload1(){
            var g = this;
            g.create = JSON.parse(JSON.stringify(g.create))
            var Upload = function (file) {
                this.file = file;
            };

            Upload.prototype.getType = function () {
                return this.file.type;
            };
            Upload.prototype.getSize = function () {
                return this.file.size;
            };
            Upload.prototype.getName = function () {
                return this.file.name;
            };
            Upload.prototype.doUpload = function () {
                var that = this;
                var formData = new FormData();

                // add assoc key values, this will be posts values
                formData.append("file", this.file, this.getName());

                $.ajax({
                type: "POST",
                url: api + '/user/web/upload',
                xhr: function () {
                    var myXhr = $.ajaxSettings.xhr();
                    if (myXhr.upload) {
                    myXhr.upload.addEventListener(
                        "progress",
                        that.progressHandling,
                        false
                    );
                    }
                    return myXhr;
                },
                success: function (data) {
                    // your callback here
                    if(data.status != 100){
                        alert("هذه الصورة غير مدعومة", 200)
                        return;
                    }
                    g.create.file_1 = data.response;
                    g.create = JSON.parse(JSON.stringify(g.create))
                },
                error: function (error) {
                    // handle error
                    alert("حدث خطأ");
                },
                async: true,
                data: formData,
                cache: false,
                contentType: false,
                processData: false,
                timeout: 60000,
                });
            };
            var file = $("#file_1")[0].files[0];
            var upload = new Upload(file);
            upload.doUpload();
        },
        upload2(){
            var g = this;
            g.create = JSON.parse(JSON.stringify(g.create))
            var Upload = function (file) {
                this.file = file;
            };

            Upload.prototype.getType = function () {
                return this.file.type;
            };
            Upload.prototype.getSize = function () {
                return this.file.size;
            };
            Upload.prototype.getName = function () {
                return this.file.name;
            };
            Upload.prototype.doUpload = function () {
                var that = this;
                var formData = new FormData();

                // add assoc key values, this will be posts values
                formData.append("file", this.file, this.getName());

                $.ajax({
                type: "POST",
                url: api + '/user/web/upload',
                xhr: function () {
                    var myXhr = $.ajaxSettings.xhr();
                    if (myXhr.upload) {
                    myXhr.upload.addEventListener(
                        "progress",
                        that.progressHandling,
                        false
                    );
                    }
                    return myXhr;
                },
                success: function (data) {
                    // your callback here
                    if(data.status != 100){
                        alert("هذه الصورة غير مدعومة", 200)
                        return;
                    }
                    g.create.file_2 = data.response
                    g.create = JSON.parse(JSON.stringify(g.create))
                },
                error: function (error) {
                    // handle error
                    alert("حدث خطأ");
                },
                async: true,
                data: formData,
                cache: false,
                contentType: false,
                processData: false,
                timeout: 60000,
                });
            };
            var file = $("#file_2")[0].files[0];
            var upload = new Upload(file);
            upload.doUpload();
        },
        upload3(){
            var g = this;
            if(!g.create.number){
              $("#file_3").val("")
              return alert("قم بكتابة رقم الهوية", 200)
            }
            if(g.create.number.length != 10){
              $("#file_3").val("")
                alert(`حقل رقم الهوية غير صحيح`, 200); g.step = 1; return g.top();
            }
            g.create = JSON.parse(JSON.stringify(g.create))
            var Upload = function (file) {
                this.file = file;
            };

            Upload.prototype.getType = function () {
                return this.file.type;
            };
            Upload.prototype.getSize = function () {
                return this.file.size;
            };
            Upload.prototype.getName = function () {
                return this.file.name;
            };
            Upload.prototype.doUpload = function () {
                var that = this;
                var formData = new FormData();

                // add assoc key values, this will be posts values
                formData.append("file", this.file, this.getName());
                console.log(g.create)
                formData.append("custom_name", g.create.number);

                $.ajax({
                type: "POST",
                url: api + '/user/web/upload',
                xhr: function () {
                    var myXhr = $.ajaxSettings.xhr();
                    if (myXhr.upload) {
                    myXhr.upload.addEventListener(
                        "progress",
                        that.progressHandling,
                        false
                    );
                    }
                    return myXhr;
                },
                success: function (data) {
                    // your callback here
                    if(data.status != 100){
                        alert("هذه الصورة غير مدعومة", 200)
                        return;
                    }
                    g.create.file_3 = data.response
                    g.create = JSON.parse(JSON.stringify(g.create))
                },
                error: function (error) {
                    // handle error
                    alert("حدث خطأ");
                },
                async: true,
                data: formData,
                cache: false,
                contentType: false,
                processData: false,
                timeout: 60000,
                });
            };
            var file = $("#file_3")[0].files[0];
            var upload = new Upload(file);
            upload.doUpload();
        },

        upload4(){
            var g = this;
            g.create = JSON.parse(JSON.stringify(g.create))
            var Upload = function (file) {
                this.file = file;
            };

            Upload.prototype.getType = function () {
                return this.file.type;
            };
            Upload.prototype.getSize = function () {
                return this.file.size;
            };
            Upload.prototype.getName = function () {
                return this.file.name;
            };
            Upload.prototype.doUpload = function () {
                var that = this;
                var formData = new FormData();

                // add assoc key values, this will be posts values
                formData.append("file", this.file, this.getName());
                console.log(g.create)

                $.ajax({
                type: "POST",
                url: api + '/user/web/upload',
                xhr: function () {
                    var myXhr = $.ajaxSettings.xhr();
                    if (myXhr.upload) {
                    myXhr.upload.addEventListener(
                        "progress",
                        that.progressHandling,
                        false
                    );
                    }
                    return myXhr;
                },
                success: function (data) {
                    // your callback here
                    if(data.status != 100){
                        alert("هذه الصورة غير مدعومة", 200)
                        return;
                    }
                    g.create.file_4 = data.response
                    g.create = JSON.parse(JSON.stringify(g.create))
                },
                error: function (error) {
                    // handle error
                    alert("حدث خطأ");
                },
                async: true,
                data: formData,
                cache: false,
                contentType: false,
                processData: false,
                timeout: 60000,
                });
            };
            var file = $("#file_4")[0].files[0];
            var upload = new Upload(file);
            upload.doUpload();
        },
        done(){
            var g = this;
            g.create = JSON.parse(JSON.stringify(g.create))
            //
            if(!g.create.number_source){ alert(`حقل مصدر الهوية مطلوب`, 200); g.step = 1; return g.top(); }
            if(!g.create.number){ alert(`حقل رقم الهوية مطلوب`, 200); g.step = 1; return g.top(); }
            if(!g.create.email && !g.create.email.includes("@") && !g.create.email.includes(".")){ alert(`حقل رقم البريد الالكتروني مطلوب`, 200); g.step = 1; return g.top(); }
            if(g.create?.number?.length != 10){
                alert(`حقل رقم الهوية غير صحيح`, 200); g.step = 1; return g.top();
            }
            if(g.create?.bank_number?.length != 22){
                alert(`حقل الآيبان يجب ان يكون 22 حرف او رقم`, 200); g.step = 1; return g.top();
            }
            if(!g.create.birth_date){ alert(`حقل تاريخ الميلاد مطلوب`, 200); g.step = 1; return g.top(); }
            if(!g.create.gender){ alert(`حقل الجنس مطلوب`, 200); g.step = 1; return g.top(); }
            if(!g.create.bank_number){ alert(`حقل رقم الحساب البنكي مطلوب`, 200); g.step = 1; return g.top(); }
            if(!g.create.bank){ alert(`حقل البنك الذي عليه الحساب مطلوب`, 200); g.step = 1; return g.top(); }
            if(!g.create.file_1){ alert(`حقل صورة من الهوية الوطنية أو الإقامة سارية بنفس النموذج المرفق مطلوب`, 200); g.step = 2; return g.top(); }
            if(!g.create.file_2){ alert(`حقل شهادة الآيبان الخاص بالحساب البنكي للمتقدم مطلوب`, 200); g.step = 2; return g.top(); }
            if(!g.create.file_3){ alert(`حقل الصورة الشخصية مطلوب`, 200); g.step = 2; return g.top(); }
            if(!g.create.hij_before){ alert(`حقل 'هل سبق لك الحج ؟' مطلوب`, 200); g.step = 3; return g.top(); }
            if(!g.create.work_before){ alert(`حقل 'هل سبق لك أن عملت في حملات الحج ؟' مطلوب`, 200); g.step = 3; return g.top(); }
            if(!g.create.about){ alert(`حقل 'اكتب عن نفسك وخبراتك ' مطلوب`, 200); g.step = 3; return g.top(); }
            if(!g.create.last_degree){ alert(`حقل 'آخر مؤهل تم الحصول عليه ' مطلوب`, 200); g.step = 3; return g.top(); }
            if(g.create.gender == 'woman'){
                if(g.create.muhrim_number?.length != 10){
                    alert(`رقم هوية المحرم غير صحيح`, 200); g.step = 3; return g.top();
                }
                if(!g.create.muhrim_phone){
                    alert(`رقم جوال المحرم مطلوب`, 200); g.step = 3; return g.top();
                }
            }
            //
            $.post(api + '/user/forms/create', {
                create: JSON.stringify(g.create),
                type: g.type,
                code: g.code
            }).then(function(r){
                if(r.status == 100){
                    g.success = "تم الارسال بنجاح"
                }else{
                    alert(r.response, 200)
                }
            }).fail(function(){
                alert("حدث خطأ في الاتصال", 200)
            })
        }
    }
}
</script>

<style>

</style>